/**
 * Share Component
 * 
 * @description
 * <p>Sets up share button functionality</p>
 * <p>On page load, Adds click events to all .social-btn and .share-btn elements.</p>
 * <p>Self-initializes when you include this module.</p> 
 * 
 * @module share
 *
 * @namespace site.share
 */
( /* @lends module:share */ function(site,$){
	"use strict";
(function($){
	var trace = {push: function() {}},
    dom = {};

	function init() {

		trace = site.utilities && site.utilities.trace ? site.utilities.trace : {push: function() {}};
        trace.push("[share.js] init()");
        dom.shareBtn = $('.social-btn, .share-btn');
		dom.shareBtn.each(function(){
            $(this).on('click', function() {
                share($(this));
            });
			
		});


    }

	function share(obj) {

        var title = obj.attr('data-title');
		var url = obj.attr('data-url');
        //var url = encodeURIComponent(obj.attr('data-url'));
        //var url = encodeURIComponent(window.location.href);
        var type = obj.attr('data-type');
        var hashtag = obj.attr('data-hashtag');

        if(type == "facebook") {
            network_url = "https://www.facebook.com/sharer/sharer.php?u="+url+'&='+title;
            window.open(network_url, "facebook_share", "width=600, height=400");
            return;
        }

        var network_url;

        if(type == "twitter") {

            /*var character_max = 240;
            var characters_over = 0;
            var message_string = title +"  #"+hashtag+" " +url;

            trace.push("message_string = "+message_string);

            if(message_string.length > character_max) {
                characters_over = message_string.length - character_max + 3;
                title = title.substring(0, title.length - characters_over);
                title = title + "...";
                trace.push("title = "+title+" characters_over = "+characters_over+" message_string.length = "+message_string.length)
            }*/
            trace.push('twitter url ========= '+url);

            network_url = "http://twitter.com/share?text="+encodeURIComponent(title)+"&url="+encodeURIComponent(url)+"&hashtags="+hashtag;

            trace.push('twitter network_url ========= '+network_url);

            window.open(network_url, "twitter_share", "width=600, height=400");
        }

        if(type == 'copy') {
            var articleUrl = window.location.href,
                textArea = document.createElement('textarea'),
                tooltip = obj.find('.tooltip'),
                tooltipText = tooltip.find('.tooltip-text'),
                msg;
            
            //textArea.value = articleUrl;
			textArea.value = url;
            $("div.social-btn div.tooltip").append(textArea);
            textArea.select();

            // Case for iOS devices
            if(navigator.userAgent.match(/ipad|ipod|iphone/i)) {
                // save current contentEditable/readOnly status
                var editable = textArea.contentEditable,
                    readOnly = textArea.readOnly;

                // convert to editable with readonly to stop iOS keyboard opening
                textArea.contentEditable = true;
                textArea.readOnly = true;

                // creare a selectable range
                var range = document.createRange();
                range.selectNodeContents(textArea);

                // select the range
                var selection = window.getSelection();
                selection.removeAllRanges();
                selection.addRange(range);
                
                textArea.setSelectionRange(0, 999999);

                // restore contentEditable/readOnly to original state
                textArea.contentEditable = editable;
                textArea.readOnly = readOnly;
            } 

            try {
                var successful = document.execCommand('copy');
                msg = successful ? 'Copied to Clipboard' : 'unsuccessful';
            } catch (err) {
                msg = 'Something went wrong...';
            }
            
            tooltipText.html(msg);

            tooltip.addClass('active');

            setTimeout(function(){
                tooltip.removeClass('active');
            }, 2500);

            $("div.social-btn div.tooltip").children('textarea').remove();
        }

    }

	

	// Public API definitions
	site.share = {
	};


	$(function(){
		init();
		$( document ).ajaxComplete(function(event, xhr, options) {
          if (options.url.toLowerCase().indexOf("api/newsroom/node") >= 0 || options.url.toLowerCase().indexOf("api/newsroom/list") >= 0) {
                init();
            }
        });
	});
	})(jQuery);
})(window.site=window.site || {}, jQuery);
